import { render, staticRenderFns } from "./ContabilitaDocumentoRigaDocumentoModalComponent.vue?vue&type=template&id=52955531&scoped=true"
import script from "./ContabilitaDocumentoRigaDocumentoModalComponent.vue?vue&type=script&lang=js"
export * from "./ContabilitaDocumentoRigaDocumentoModalComponent.vue?vue&type=script&lang=js"
import style0 from "./ContabilitaDocumentoRigaDocumentoModalComponent.vue?vue&type=style&index=0&id=52955531&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52955531",
  null
  
)

export default component.exports